"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollHandler = void 0;
var _react = require("react");
/**
 * useScrollHandler
 * This hook adds event to target element detect scroll changes
 * @param {Object} target The ref object of the target element you want to listen to.
 * @param {boolean} isRTL Determines if the scrolling direction is right-to-left.
 * @param {function} setActiveTab Function to set the current active tab index.
 */
const useScrollHandler = (target, isRTL, setActiveTab) => {
  (0, _react.useEffect)(() => {
    const element = target?.current;
    if (!element) {
      return;
    }
    const handleScroll = () => {
      if (element) {
        const containerWidth = target.current.offsetWidth;
        let scrollPos = target.current.scrollLeft;
        if (isRTL) {
          if (scrollPos <= 0) {
            scrollPos = Math.abs(scrollPos);
          } else {
            scrollPos = element.scrollWidth - element.clientWidth - scrollPos;
          }
        }
        const currentIndex = Math.round(scrollPos / containerWidth);
        setActiveTab(currentIndex);
      }
    };
    element.addEventListener('scroll', handleScroll);
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [isRTL, target, setActiveTab]);
};
exports.useScrollHandler = useScrollHandler;